import i18n from "../i18n/i18n";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateLoginInput(email, password) {
  if (!email && !password) {
    return i18n.t("errors.pleaseEnterEmailAndPassword", "Please enter email and password.");
  }
  if (!email) {
    return i18n.t("errors.pleaseEnterEmail", "Please enter your email address.");
  }
  if (!emailRegex.test(email)) {
    return i18n.t("errors.pleaseEnterValidEmail", "Please enter a valid email address.");
  }
  if (!password) {
    return i18n.t("errors.pleaseEnterPassword", "Please enter your password.");
  }
  return null;
}

export function parseLoginError(error) {
  const status = error?.status;

  if (!status) {
    return i18n.t("errors.unexpectedError", "An unexpected error occurred. Please try again later.");
  }

  switch (status) {
    case 400:
      return i18n.t("errors.invalidRequest", "Invalid request. Please check your input.");
    case 401:
      return i18n.t("errors.incorrectCredentials", "Incorrect email or password. Please try again.");
    case 403:
      return i18n.t("errors.accessDenied", "Access denied. Please contact support.");
    case 500:
      return i18n.t("errors.serverError", "Server error. Please try again later.");
    case 502:
    case 503:
    case 504:
      return i18n.t("errors.serviceUnavailable", "Service is temporarily unavailable. Please wait a moment and try again.");
    default:
      return i18n.t("errors.genericError", "An error occurred. Please try again.");
  }
}
